import { BackendModel } from '../core/backend.service';
import { TipoMoneda } from './tipoMoneda.model';
import { Parametric } from './parametric.model';

export class Saldo extends BackendModel {
    static path = '/saldos/';
    moneda: Parametric;
    monto: Float32Array;
}



// WEBPACK FOOTER //
// ./src/app/cliente/saldo.model.ts